<template>
    <span>
        <span v-if="!status" class="grey--text text--lighten-1">-</span>
        <v-chip
            v-else
            :color="statusConfig.color"
            :x-small="xSmall"
            :small="!xSmall"
            dark
        >
            <v-icon left x-small>{{ statusConfig.icon }}</v-icon>
            {{ statusConfig.label }}
        </v-chip>
    </span>
</template>

<script>
const STATUS_MAP = {
    concluded:  { color: 'success',   icon: 'mdi-check-circle',  label: 'Concluída' },
    processing: { color: 'info',      icon: 'mdi-clock-outline', label: 'Aguardando' },
    uploaded:   { color: 'blue-grey', icon: 'mdi-upload',        label: 'Enviado' },
    pending:    { color: 'warning',   icon: 'mdi-timer-sand',    label: 'Pendente' },
    failed:     { color: 'error',     icon: 'mdi-alert-circle',  label: 'Falhou' },
};

const DEFAULT_STATUS = { color: 'grey', icon: 'mdi-help-circle', label: 'Desconhecido' };

export default {
    name: 'SysTermDigitalSignatureStatus',
    props: {
        status: {
            type: String,
            default: null,
        },
        xSmall: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        statusConfig() {
            return STATUS_MAP[this.status] || DEFAULT_STATUS;
        },
    },
};
</script>
